/**
 * Turns a grid into a slider on small viewports.
 * @module GridSlide
 * @return {Object} public methods
 */

const GridSlide = (function () {

    /**
     * On small viewports one sliders will be rendered.
     * @param {jQuery} $wrapper
     * @param {string} maxWidth
     */
    function init($wrapper, maxWidth) {
        if ($wrapper.length === 0) return false;

        var slickInitialised = $wrapper.hasClass('slick-slider') ? true : false;

        if (!maxWidth) maxWidth = "760px";

        if (matchMedia('only screen and (max-width: ' + maxWidth + ')').matches) {
            if (!slickInitialised) {
                $wrapper.slick({
		    accessibility: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: 1,
                    variableWidth: true
                });
            }
        } else {
            if (slickInitialised) {
                $wrapper.slick('unslick');
            }
        }
    }

    /**
     * On small viewports two sliders will be rendered, sorted by type.
     * @param {jQuery} $wrapperStage
     * @param {jQuery} $wrapperInfo
     * @param {string} maxWidth
     */
    function initProductFamilies($wrapperStage, $wrapperInfo, maxWidth) {
        if($wrapperStage.length === 0 || $wrapperInfo.length === 0) return false;

        var slickInitialised = $wrapperStage.hasClass('slick-slider') ? true : false;
        var originalWrapper;

        if (!maxWidth) maxWidth = "760px";

        if (matchMedia('only screen and (max-width: ' + maxWidth + ')').matches) {
            if (!slickInitialised) {

                // build originalWrapper to save grid elements to
                if (rl.$('.originalWrapper').length === 0) {
                    originalWrapper = rl.$('<div class="originalWrapper" style="display:none"></div>');
                    $wrapperStage.before(originalWrapper);

                    // append current elements to originalWrapper
                    rl.$('.product-families__wrapper--stage .gridslide__item').clone().appendTo(originalWrapper);
                }

                // clone article elements to info
                rl.$('.product-families__wrapper--stage .product-families__item--article').clone().appendTo('.product-families__wrapper--info');

                // remove all article elements from stage
                rl.$('.product-families__wrapper--stage .product-families__item--article').remove();

                $wrapperStage.slick({
		    accessibility: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: 1,
                    variableWidth: true
                });

                $wrapperInfo.slick({
		    accessibility: false,
                    dots: false,
                    speed: 300,
                    slidesToShow: 1,
                    variableWidth: true
                });

                if (rl.$('.originalWrapper').find('.product-families__item--article').length > 0) {
                    rl.$('#magazine-hint').show();
                }
            }
        } else {
            if (slickInitialised) {
                $wrapperStage.slick('unslick');
                $wrapperInfo.slick('unslick');
                rl.$('.product-families__wrapper--stage .gridslide__item').remove();
                rl.$('.product-families__wrapper--info .gridslide__item').remove();
                rl.$('.originalWrapper .gridslide__item').clone().appendTo('.product-families__wrapper--stage');
                rl.$('#magazine-hint').hide();
            }
        }
    }

    // Return public methods
    return {
        init: init,
        initProductFamilies: initProductFamilies
    };
})();

window.GridSlide = GridSlide;
export default GridSlide;
